import * as React from "react";
import styles from "./Attribution.module.css";
import { AttributionAttributes } from "@/types/sites";
import { CmsImage } from "@/components/common/CmsImage";

export const Attribution = ({
    attribution,
    className
}: {
    attribution: AttributionAttributes;
    className: string
}): React.ReactElement => {
    return (
        <div className={[styles.container, className].join(" ")}>
            <div className={styles.imgWrapper}>
                {/* TODO (maybe?): auto colour the SVG https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-styles-with-css */}
                <CmsImage cmsMedia={attribution?.logo} desiredHeight={25} />
            </div>
            <div className={styles.text}>{attribution?.attribution}</div>
        </div>
    );
};
